import React from 'react';

import "./work.css";
import Works from './Works';

const Work = () => {
  return (
    <section className="work section" id="portfolio">
        <h2 className="section__title">Portfolio</h2>
        <span className="section__subtitle">Most recent works</span>

        <Works />
        <div className="close__section">
          <h2 className="close__title">And that's me, in a nutshell :D</h2>
        </div>
    </section>
  )
}

export default Work